/* eslint-disable */
import changeCase from 'change-object-case';
import moment from 'moment';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Button, Form, InputGroup, FormGroup, FormControl, Radio, ControlLabel, HelpBlock, Checkbox, Alert, Glyphicon } from 'react-bootstrap';
import { ss, url, authJsonHeader, mapDispatch } from '../../utils/util';
import Highlighter from "react-highlight-words";

import OzFormComponent from './OzFormComponent';
import './ScheduleForm.css';

import {
} from '../../actions';


class ScheduleForm extends OzFormComponent {

  static fields = [
    'roomId',
    'effectiveFrom',
  ];

  static cleaners = {
    effectiveFrom: { inbound: 'date', outbound: 'date' },
  };

  getValues() {
    let values = super.getValues();
    if (this.state.when == 'today') {
      values.effectiveFrom = moment().format('YYYY-MM-DD');
    }
    return values;
  }

  renderBody() {
    let whenOptions = [
      ['today', 'Today'],
      ['future', 'At a future date'],
    ];

    let askWhen = !this.props.edit;

    return (
      <div className="ScheduleForm">
        {askWhen && this.renderFormGroup('When does this schedule take effect?', 'radio', 'when', whenOptions)}
        {(!askWhen || this.state.when == 'future') && this.renderFormGroup('Select a date for this schedule to take effect', 'date', 'effectiveFrom', { isOutsideRange: () => false })}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ScheduleForm);



/** WEBPACK FOOTER **
 ** ./src/components/partials/ScheduleForm.js
 **/